import { useTranslation } from 'react-i18next';

import { Button } from '@components/Button';
import { CrossIcon } from '@components/Icons';
import Modal, { IconBlock, ActionBlock, Title } from '@components/Modal';

const languageNamespace = 'printing-modals';

import styles from './PrintOptionsModal.module.scss';

interface PrintModalProps {
  title: string[];
  print: () => void;
  printAll: () => void;
  onClose?: () => void;
}

export const PrintOptionsModal = ({ title, print, printAll, onClose }: PrintModalProps) => {
  const { t } = useTranslation([languageNamespace]);
  return (
    <Modal minWidth="42rem">
      {!!onClose && (
        <div className={styles.closeButton}>
          <Button
            appearance="text"
            text=""
            icon={() => <CrossIcon size={32} className={styles.closeIcon} />}
            onClick={onClose}
          />
        </div>
      )}
      <IconBlock icon="printIcon" />
      <Title title={title} titleWeight="bolder" />
      <ActionBlock
        actions={[
          {
            appearance: 'secondary',
            text: t('printCurrentPage'),
            onClick: print,
          },
          {
            appearance: 'primary',
            text: t('printAll'),
            onClick: printAll,
          },
        ]}
      />
    </Modal>
  );
};
